export default "__VITE_ASSET__52dbdc1d__"